export default __webpack_public_path__ + "static/media/sensotrend_connect_select_uploader.2108c86b.png";